import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, IconButton } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

const PerguntaTable = ({ perguntasFiltradas, openModal, excluirPergunta, filtro }) => {

  // Função para destacar o texto
  const destacarTexto = (texto, filtro) => {
    if (!filtro) return texto; // Se não houver filtro, retorna o texto original
    
    const partes = texto.toLowerCase().split(filtro.toLowerCase());
    const termoFiltrado = texto.substring(
      texto.toLowerCase().indexOf(filtro.toLowerCase()),
      texto.toLowerCase().indexOf(filtro.toLowerCase()) + filtro.length
    );
    
    return (
      <>
        {partes.map((parte, index) => (
          <span key={index}>
            {parte}
            {index < partes.length - 1 && (
              <span style={{ backgroundColor: 'yellow' }}>{termoFiltrado}</span>
            )}
          </span>
        ))}
      </>
    );
  };

  // Função para renderizar as perguntas e subperguntas
  const renderPerguntas = (perguntas, nivel = 1) => {
    return perguntas.map(pergunta => (
      <React.Fragment key={pergunta.id}>
        <TableRow
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '10px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
          }}
        >
          <TableCell sx={{ paddingLeft: `${nivel * 20}px`, paddingY: '10px', width: '20%' }}>
            {destacarTexto(pergunta.codigo, filtro)} {/* Destaque no código */}
          </TableCell>
          <TableCell sx={{ paddingLeft: `${nivel * 20 + 40}px`, paddingY: '10px', width: '40%' }}>
            {destacarTexto(pergunta.texto, filtro)} {/* Destaque no texto da pergunta */}
          </TableCell>

          <TableCell sx={{ paddingY: '10px', display: 'flex', justifyContent: 'space-around' }}>
            <Tooltip title="Adicionar Subpergunta">
              <span>
                <IconButton onClick={() => openModal('novo', pergunta, true)}>
                  <AddIcon color="primary" />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title="Editar Pergunta">
              <span>
                <IconButton onClick={() => openModal('editar', pergunta)}>
                  <EditIcon color="primary" />
                </IconButton>
              </span>
            </Tooltip>

            <Tooltip title="Excluir Pergunta">
              <span>
                <IconButton onClick={() => excluirPergunta(pergunta.id)}>
                  <DeleteIcon color="secondary" />
                </IconButton>
              </span>
            </Tooltip>
          </TableCell>
        </TableRow>
        {pergunta.subperguntas && renderPerguntas(pergunta.subperguntas, nivel + 1)}
      </React.Fragment>
    ));
  };

  return (
    <TableContainer component={Paper} sx={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
      <Table sx={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>Código</TableCell>
            <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Pergunta</TableCell>
            <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderPerguntas(perguntasFiltradas)}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default PerguntaTable;
